import React, { useEffect, useState } from 'react';
import { eventsAPI, unwrapList } from '../../services/api';
import DeskStation from './DeskStation';

const CheckInStation = () => {
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState('');
  const [walkIn, setWalkIn] = useState(false);

  useEffect(() => {
    eventsAPI.adminList().then((response) => {
      const rows = unwrapList(response.data).filter((event) => event.status !== 'cancelled');
      setEvents(rows);
      if (rows[0]) setEventId(String(rows[0].id));
    });
  }, []);

  return (
    <DeskStation
      title="簽到櫃台"
      hint="掃描器請使用鍵盤模式。掃入此欄後按 Enter 即簽到。"
      selected={eventId}
      onSelect={setEventId}
      options={events.map((event) => (
        <option key={event.id} value={event.id}>{event.title}</option>
      ))}
      extra={(
        <label className="pos-check">
          <input type="checkbox" checked={walkIn} onChange={(event) => setWalkIn(event.target.checked)} />
          現場報名並簽到
        </label>
      )}
      onScan={async (q) => {
        const response = await eventsAPI.checkIn({
          q,
          event_id: eventId,
          register_and_check_in: walkIn,
        });
        return response.data;
      }}
    />
  );
};

export default CheckInStation;
